export default "__VITE_ASSET__Cxamy_rU__"